"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useTheme } from "@owlcat/theme";
import { Button } from "@owlcat/ui";
/**
 * Shared light/dark toggle for every fleet app header. Cycles the next-themes
 * SETTING between light and dark (writing the shared owlcat-theme cookie via
 * @owlcat/theme's ThemeProvider, so sibling apps inherit the choice). Renders a
 * stable placeholder until mounted to avoid a hydration mismatch (the server has
 * no resolved theme). Inline SVG — no icon dependency.
 *
 * `label` is the accessible name (each app passes its own i18n string; defaults
 * to English so the package stays i18n-free).
 */
export function ThemeToggle({ label = "Toggle theme" }) {
    const { resolvedTheme, setTheme } = useTheme();
    const [mounted, setMounted] = useState(false);
    useEffect(() => setMounted(true), []);
    const isDark = resolvedTheme === "dark";
    return (_jsx(Button, { variant: "outline", size: "icon", "aria-label": label, title: label, onClick: () => setTheme(isDark ? "light" : "dark"), children: mounted ? (isDark ? (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "size-5", "aria-hidden": true, children: [_jsx("circle", { cx: "12", cy: "12", r: "4" }), _jsx("path", { d: "M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" })] })) : (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "size-5", "aria-hidden": true, children: _jsx("path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" }) }))) : (_jsx("span", { className: "size-5" })) }));
}
